import Header from '@Layouts/Header/Header'
import './not-found.scss'
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow'
import { useHistory, useLocation } from 'react-router'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import {
    EClientPermissions,
    EEducatorPermissions,
    EInspectionPermissions,
    EMedicalPermissions,
} from '@Enum/auth.enum'

interface INotFoundComponent {
    permissions: string[] | undefined
}

function NotFoundComponent(props: INotFoundComponent) {
    // core section
    const { permissions } = props
    const history = useHistory()
    const location = useLocation()
    const ac = new AbortController()

    // hooks section
    useEffect(() => {
        const authRoutes = [
            '/register',
            '/create-profile-step-1',
            '/create-profile-step-2',
        ]
        if (!permissions?.length && !authRoutes?.includes(location?.pathname))
            history.push('/login')
        return () => {
            ac.abort()
        }
    }, [permissions])

    // functions section
    const handleGoBack = () => {
        if (permissions?.includes(EClientPermissions.LOGIN)) {
            history.push('/dashboard')
        } else if (permissions?.includes(EEducatorPermissions.LOGIN)) {
            history.push('/dashboard')
        } else if (permissions?.includes(EMedicalPermissions.LOGIN)) {
            history.push('/medical-home')
        } else if (permissions?.includes(EInspectionPermissions.LOGIN)) {
            history.push('/inspection-info')
        } else {
            history.push('/')
        }
    }

    // main
    return (
        <>
            {permissions?.length ? (
                <>
                    <Header />
                    <div className="not-found-wrapper">
                        <div className="text-wrapper">
                            <div className="not-found-container">
                                <p className="m-0">OOPS! Page not found</p>
                                <h1>404</h1>
                                <p>
                                    We are sorry, but the page you are requested
                                    was not found
                                </p>
                                <div className="w-100 text-center">
                                    <div
                                        className="custom-button"
                                        onClick={handleGoBack}
                                    >
                                        Back Home <DoubleArrowIcon />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    )
}

interface INotFound {
    permissions?: string[]
}

function NotFound(props: INotFound) {
    const { permissions } = props
    return <NotFoundComponent permissions={permissions} />
}

const mapStateToProps = (store: any) => {
    const permissions = store?.auth?.user?.permissions

    return {
        permissions,
    }
}

export default connect(mapStateToProps, null)(NotFound)
